import React from "react"
import { NavLink } from "react-router-dom";
import Toggle from './ThemeToggle'
import './styles/home.css'

const Navbar = () =>{
    return(
        <nav className="sticky-nav font-bvp flex justify-between items-center max-w-4xl w-full p-8 my-0 md:my-0 mx-auto bg-white dark:bg-black bg-opacity-60">
            <a href="#skip" className="sr-only focus:not-sr-only">Skip to content</a>
            {/* <button aria-label="Toggle Dark Mode" type="button" class="bg-gray-200 dark:bg-gray-800 rounded p-3 h-10 w-10">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" class="h-4 w-4 text-gray-800 dark:text-gray-200">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
                </svg>
            </button> */}
            <Toggle />
            <div>
                <NavLink 
                    exact 
                    className="p-1 sm:p-4 text-gray-900 dark:text-gray-100 hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500" 
                    activeClassName="text-purple-500"  
                    to="/">
                Home
                </NavLink>
                <NavLink 
                    exact 
                    className="p-1 sm:p-4 text-gray-900 dark:text-gray-100 hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500" 
                    activeClassName="text-purple-500"  
                    to="/blog">
                Blog
                </NavLink>
                <NavLink 
                    exact 
                    className="p-1 sm:p-4 text-gray-900 dark:text-gray-100 hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500" 
                    activeClassName="text-purple-500"  
                    to="/projects">
                Projects
                </NavLink>
                <NavLink 
                    exact 
                    className="p-1 sm:p-4 text-gray-900 dark:text-gray-100 hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500" 
                    activeClassName="text-purple-500"  
                    to="/contact">
                Contact
                </NavLink>
            </div>
        </nav>
    //     <nav className="
    //     sticky-nav
    //     flex justify-between
    //     items-center
    //     max-w-4xl
    //     w-full
    //     p-8 
    //     my-0 
    //     md:my-0 
    //     mx-auto 
    //     bg-white 
    //     dark:bg-black 
    //     bg-opacity-60
    //     "
    //     >
    //     <div>
    //         <a href="#" className="dark:text-purple-400">
    //             Sahil Jena
    //         </a>
    //     </div>

    //     <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         id="menu-button"
    //         className="h-6 w-6 cursor-pointer md:hidden block"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke="currentColor"
    //     >
    //         <path
    //             stroke-linecap="round"
    //             stroke-linejoin="round"
    //             stroke-width="2"
    //             d="M4 6h16M4 12h16M4 18h16"
    //         />
    //     </svg>

    //     <div className="hidden w-full md:flex md:items-center md:flex-around md:w-auto" id="menu">
    //         <ul
    //             className="
    //                 pt-4
    //                 text-base text-gray-700
    //                 md:flex
    //                 md:justify-between 
    //                 md:pt-0"
    //         >
    //             <li>
    //                 <NavLink exact className="md:p-4 py-2 block hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500" activeClassName="text-purple-500"  to="/">Home</NavLink>
    //             </li>
    //             <li>
    //                 <NavLink exact className="md:p-4 py-2 block hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500"  activeClassName="text-purple-500"   to="/blog">Blog</NavLink>
    //             </li>
    //             <li>
    //                 <NavLink exact className="md:p-4 py-2 block hover:text-purple-400 dark:hover:text-purple-400 dark:text-slate-300 focus:text-purple-500  dark:focus:text-purple-500"  activeClassName="text-purple-500"   to="/projects">Projects</NavLink>
    //             </li>
    //         </ul>
    //         <Toggle />
    //     </div>
        
    // </nav>
    );
}

export default Navbar